module.exports = __webpack_public_path__ + "img/cute_natural_doodle_8.0a8262fe.png";